import {
  IDesignation,
  IUserInfo,
  PATIENT_STATUS,
} from "@home-health-notify/domain";
import { useContext, useState } from "react";
import {
  AssignedPatientsContext,
  getAssignedPatientsByStatus,
} from "hhn-commons";
import AssignedPatient from "./AssignedPatient";
import {
  ArrowDown,
  AssignedPatientsContainer,
  AssignedPatientsList,
  AssignedPatientsLoader,
  AssignedPatientsTitle,
} from "./AssignedPatients.style";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AssignedPatientsProgressDetails from "./AssignedPatientsProgressDetails";
import { AssignedPatientsByStatusModal } from "./AssignedPatientsByStatusModal";
import ProgressLoader from "../../loader/ProgressLoader";

const AssignedPatients = ({ userInfo }: { userInfo: IUserInfo }) => {
  const { isLoading, assignedPatients } = useContext(AssignedPatientsContext);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPatientStatus, setSelectedPatientStatus] =
    useState<PATIENT_STATUS>();

  const handleModalOpen = (patientStatus: PATIENT_STATUS) => {
    setIsModalOpen(true);
    setSelectedPatientStatus(patientStatus);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const statusesToDisplay = [
    PATIENT_STATUS.PENDING_SOC,
    PATIENT_STATUS.ACTIVE,
    PATIENT_STATUS.HOSPITALIZED,
    PATIENT_STATUS.PENDING_ROC,
  ];
  if (isLoading) {
    return (
      <AssignedPatientsLoader>
        <ProgressLoader />
      </AssignedPatientsLoader>
    );
  }
  return (
    <AssignedPatientsContainer data-testid="chat-info-assigned-patients-section">
      <AssignedPatientsTitle>Patients</AssignedPatientsTitle>
      <AssignedPatientsList>
        {statusesToDisplay.map(status => (
          <AssignedPatient
            key={status}
            patientStatus={status}
            patients={getAssignedPatientsByStatus(assignedPatients, status)}
            openModal={handleModalOpen}
          />
        ))}
      </AssignedPatientsList>
      {userInfo.department && (
        <>
          <ArrowDown icon={<ArrowDropDownIcon />} color="disabled" />
          <AssignedPatientsProgressDetails
            department={userInfo.department as IDesignation}
            patients={getAssignedPatientsByStatus(
              assignedPatients,
              PATIENT_STATUS.ACTIVE,
            )}
          />
        </>
      )}
      {selectedPatientStatus && (
        <AssignedPatientsByStatusModal
          closeModal={handleModalClose}
          isModalOpen={isModalOpen}
          patientStatus={selectedPatientStatus}
        />
      )}
    </AssignedPatientsContainer>
  );
};

export default AssignedPatients;
